import { InputProps, SelectProps, TextAreaProps } from '@heroui/react';

export const inputProps: InputProps = {
  size: 'lg',
  radius: 'lg',
  variant: 'bordered',
  labelPlacement: 'outside',
  classNames: {
    input: 'text-sm placeholder:text-gray-400 dark:placeholder:text-gray-500 dark:text-gray-100',
    inputWrapper: 'h-[50px] bg-white dark:bg-[#242a33] border-1 border-gray-300 dark:border-[#374151] rounded-md shadow-none transition-colors group-data-[focus=true]:border-[#E07B2D] dark:group-data-[focus=true]:border-[#E07B2D] group-data-[hover=true]:border-gray-400 dark:group-data-[hover=true]:border-[#4b5563]',
    label: 'dark:text-gray-300',
    description: 'dark:text-gray-400',
    errorMessage: 'dark:text-red-400',
  },
};

export const textareaProps: TextAreaProps = {
  size: 'lg',
  radius: 'sm',
  variant: 'bordered',
  labelPlacement: 'outside',
  classNames: {
    input: 'text-sm placeholder:text-gray-400 dark:placeholder:text-gray-500 dark:text-gray-100',
    inputWrapper: 'bg-white dark:bg-[#242a33] border-1 border-gray-300 dark:border-[#374151] rounded-md shadow-none transition-colors group-data-[focus=true]:border-[#E07B2D] dark:group-data-[focus=true]:border-[#E07B2D] group-data-[hover=true]:border-gray-400 dark:group-data-[hover=true]:border-[#4b5563]',
    label: 'dark:text-gray-300',
    description: 'dark:text-gray-400',
    errorMessage: 'dark:text-red-400',
  },
};

export const selectProps: Partial<SelectProps> = {
  size: 'lg',
  radius: 'sm',
  variant: 'bordered',
  labelPlacement: 'outside',
  classNames: {
    base: 'w-full',
    trigger: 'h-[50px] bg-white dark:bg-[#242a33] border-1 border-gray-300 dark:border-[#374151] rounded-md shadow-none transition-colors data-[hover=true]:border-gray-400 dark:data-[hover=true]:border-[#4b5563] data-[focus=true]:border-[#E07B2D] dark:data-[focus=true]:border-[#E07B2D]',
    value: 'text-sm font-normal text-gray-700 dark:text-gray-100',
    label: 'dark:text-gray-300',
    popoverContent: 'rounded-md dark:bg-[#242a33] dark:border-[#374151]',
    listbox: 'dark:bg-[#242a33]',
    errorMessage: 'dark:text-red-400',
  },
};
